import { GlassCocktailIcon } from './GlassCocktailIcon';

/**
 * author: Google
 * id 9291BDB1-CE57-4802-8CD2-7AD2ED9D9959
 * name glass-cocktail
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/glass-cocktail.svg
 * tags
 * - Food / Drink 
 */
export const AlcoholIcon = GlassCocktailIcon;
export default AlcoholIcon